module.exports = __webpack_public_path__ + "img/1.a55e59da.jpg";